import React from 'react';

import QuotaArcorZonals  from 'components/Tvendo/Sale/QuotaBPartner/Arcor/QuotaZonals/List.js';

export default function () {
  return <QuotaArcorZonals  />;
}
